import mapSpaceItem from '@src/libs/utils/mapSpaceItem';

export const mapSpaces = (serverItems, cityId, town, favs, filters) => {
	const favIds = favs?.spaces.map(({ id }) => id) || [];
	const first_id = +filters.first_id;
	const mapper = mapSpaceItem(favIds, cityId, town, first_id);
	return serverItems.map(mapper);
};
